import { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, Progress } from "..";
import { Alert } from "@mui/material";

const Warning = () => <Alert severity="warning">Removing subscriptions</Alert>;

const renderResponse = (res) => {
  if (res.error) {
    return <Alert severity="error">{res.error}</Alert>;
  }
  if (!res.status) {
    return (
      <Alert severity="error">
        {res.errors.map((error) => (
          <div key={error.row}>
            <b>Error:</b> Row <b>{error.row}</b> Reason: <b>{error.message}</b>
          </div>
        ))}
      </Alert>
    );
  }

  const columns = [
    {
      field: "name",
      headerName: "Newsletter Name",
      flex: 1,
    },
    {
      field: "total",
      headerName: "Removals",
      flex: 1,
    },
  ];

  return (
    <div>
      <Warning />
      Rows in CSV: <b>{res.row_count}</b>
      <br />
      Total Removals: <b>{res.total_subscriptions}</b>
      <br />
      Rows without a removal: <b>{res.total_without_list}</b>
      <br />
      <h2>Detected Removals</h2>
      <DataGrid rows={res.lists} columns={columns} />
    </div>
  );
};

export const DetectRemovals = ({ selectedFile, setNextStepDisabled }) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!selectedFile) {
      setLoading(false);
      setResponse({ error: "Please select a file" });
      return;
    }

    const formData = new FormData();
    formData.append("upload", selectedFile, selectedFile.name);

    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_BACKEND_API}/detectRemovals`, formData)
      .then((response) => response.data)
      .then((data) => {
        setResponse(data);
        if (data.status) {
          setNextStepDisabled(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setResponse({ error: error.message });
      });
  }, [selectedFile, setNextStepDisabled]);

  if (loading)
    return (
      <>
        <Warning />
        <Progress text="Running Removals Detection" />
      </>
    );

  return response ? renderResponse(response) : "";
};
